import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import { CommonUtilities } from '../../commonUtils';
import AssetLinkingServices from './AssetLinkingServices';
import AssetLinkingFlyout from './AssetLinkFlyout';
import Pagination from '../Header/Pagination';
import TooltipList from '../Common/tooltip';

export default function AssetLinking(param: any) {
 
    const [isOpen, setIsOpen] = React.useState(false);
    const [showtab, setShowTab] = useState(1);
    const [showView, setShowView] = useState(2);
    const [totalRows, setTotalRows] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [projectAsset, initProjectAsset] = useState<any[]>([]);
    console.log(param) 

    const Data: any = {
        ProjectId: param.data.projectId,
        export: 0,
        type: "contract",
        pageNumber: 1,
        pageSize: 10
    }

    useEffect(() => {
        Data.type = param.type === 1 ? "contract" : param.type === 3 ? "song" : param.type === 4 ? "release" : param.type === 2 ? "track" : "";
        //param.type==1? 1 :param.type==2? 3 :param.type==3? 2  :param.type==4? 4 :1
        setShowTab(param.type === 1 ? 1 : param.type === 2 ? 2 : param.type === 3 ? 3 : param.type === 4 ? 4 : 1);
        getAssetLinking();
    }, [isOpen])

    const getAssetLinking = () => {
        Data.type = showtab === 1 ? "contract" : showtab === 3 ? "song" : showtab === 4 ? "release" : showtab === 2 ? "track" : "";
        var dataLink = 'projectId=' + Data.ProjectId + '&assetType=' + Data.type + '&pageNumber=' + Data.pageNumber + '&pageSize=' + Data.pageSize;
        if (Data.searchFor) {
            dataLink = dataLink + '&searchFor=' + Data.searchFor;
        }

        AssetLinkingServices.projectAssetListMyAsset(dataLink)
            .then((res) => {
                initProjectAsset(res);
                setTotalRows((res.length !==0 ? res[0].totalRows : 0))
            })
        var dataLink = 'projectId=' + Data.ProjectId + '&type=' + Data.type + '&pageNumber=' + Data.pageNumber + '&pageSize=' + Data.pageSize;
        AssetLinkingServices.projectAssetList(dataLink)
            .then((res) => {
                // initProjectAsset(res);
                //  setTotalRows (projectAsset[0].totalRows)
            })

    }

    const toUnLinked = (value: any, btnNum: any) => {
        var dataLink = "";
        if (btnNum === 1) {
            dataLink = value.projectAssetId;
            AssetLinkingServices.unlinkAsset(dataLink)
        } else if (btnNum === 2) {
            dataLink = 'projectId=' + Data.ProjectId + "&kontactCode=" + value.contractArtistCode + "&assetType=contract";
            AssetLinkingServices.unlinkContact(dataLink)
        }
        getAssetLinking();

    }

    const addToProject = (data: any, btnNum: any) => {
        //projectId=50434&catlognumber=0000000052313
        var dataLink = "";
        if (btnNum === 1) {
            dataLink = "projectId=" + Data.ProjectId + "&catlognumber=" + data.code;
            AssetLinkingServices.addTracksToProject(dataLink)
        }
    }

    const dropDown = (array: any, key: any) => {

        var value = (array.filter((data: any) => (data.key === key)))
        if (key) {
            return value[0].value;
        } else {
            return " ";
        }
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        //dataLink = 'pageSize=' + Data.pageSize +'&pageNumber=' + Data.pageNumber;
        getAssetLinking();
    }

    const onClose = () => {
        //getAssetLinking();
        param.AssetLinkClose();
    }
    return (
        <div >
            <button className="icon-btn primary pull-right mb" onClick={() => setIsOpen(!isOpen)}>Asset Linking</button>

            <Drawer open={param.openAssetLink}
                onClose={onClose}
                direction='right'
                className='react-drawer mbl'
                style={{ width: "100%" }}>

                <div className="box noBorderRadius noBorder ws-8 pull-right ">

                    <div className="box-header  noBorderRadius bg-blue pLarge">
                        Linked Assets
                        {/* <i className="icon-close pull-right pLarge" onClick={() => setIsOpen(!isOpen)}></i> */}
                    </div>

                    <div className='box ws-3 pm'>
                        <div className="ws-12">
                            <div className="pLarge ws-12 border-bottom" >
                                <label className="ws-12 text-left mts text-bold text-l ">
                                    {param.data.projectName}
                                </label>
                                <div className="label-entries text-left ws-12 mtl mb ">
                                    {param.data.projectCode}
                                </div>
                            </div>
                        </div>

                        <div className="ws-12">
                            <div className="pLarge ws-12 border-bottom" >
                                <label className="ws-12 text-left mts text-bold text-l">
                                    {param.data.projectOwner}
                                </label>

                                <label className="ws-12 text-left mts " >Project Owner</label>
                                <label className="ws-12 text-left mts text-bold text-l">

                                </label>

                            </div>
                        </div>

                        <div className="ws-12">
                            <div className="pLarge ws-12 pull-left">
                                <div className="label-entries text-left ws-12 mtl mb">
                                    Project Status
                                </div>
                                <div className="label-entries text-left ws-12 mtl mb">
                                    <button className={(param.data.status !==null) ? "btn-lg ws-12 box btn-warning" : "hide"}>
                                    
                                        {CommonUtilities.lookUpTypeListByKey("ContractStatus", param.data.status, "value")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='ws-9 landing'>


                        <div className="ws-12 box-content">
                            <ul className="nav nav-tabs ws-9">
                                <li className={showtab === 1 ? "active mr" : "mr"} onClick={() => { setShowTab(1); Data.type = "contract"; getAssetLinking(); }}>Contracts</li>
                                <li className={showtab === 2 ? "active mr" : "mr"} onClick={() => { setShowTab(2); Data.type = "track"; getAssetLinking(); }}>Tracks</li>
                                <li className={showtab === 3 ? "active mr" : "mr"} onClick={() => { setShowTab(3); Data.type = "song"; getAssetLinking(); }}>Songs</li>
                                <li className={showtab === 4 ? "active mr" : "mr"} onClick={() => { setShowTab(4); Data.type = "release"; getAssetLinking(); }}>Release</li>


                            </ul>

                            <div className="pull-right pbl">
                                <button className={showView === 1 ? "btn pbl active" : "btn pbl"} onClick={() => setShowView(1)}>
                                    <i className='icon-list p0'></i></button>
                                <button className={showView === 2 ? "btn-s active" : "btn-s"} onClick={() => setShowView(2)}>
                                    <i className='icon-grid' style={{ fontSize: "25px" }}></i></button>
                            </div>

                        </div>

                        <div className="ws-12 ptl box-content">
                            <div className="ws-6 pull-left">
                                <button className="icon-btn edit m0 ws-3 pull-right"
                                    onClick={() => { Data.searchFor = searchValue; getAssetLinking(); }}>Search </button>
                                <input type="text" className="ws-9 m0 heightReset noBorderRadius"
                                    onChange={(e) => { setSearchValue(e.target.value) }}
                                    onKeyDown={(e) => { if (e.code === "Enter") { Data.searchFor = searchValue; getAssetLinking(); } }} />
                            </div>

                            <AssetLinkingFlyout showtab={showtab} data={param.data} onClose={onClose} />
                        </div>

                        <div className='box-content ps ptxl '>
                            <div className="ws-12 text-bold mbl mll ">Showing ({totalRows}) results</div>

                            {
                                projectAsset.map(post => {
                                    return (
                                        <>
                                            <div className={showView === 2 ? "box w-32 noBorder mb ml height200" : "box ws-12 noBorder mb height100"} >

                                                <div className="ws-12">

                                                    <div className="pull-left ws-10 text-average text-bold ml pm">
                                                        <span className="ws-12">{post.name} ({post.code} )</span>
                                                        <span className="ws-12"> <span >{post.trackArtistDisplay}</span></span>

                                                        <hr className={showView === 2 ? "hide" : "ws-12"}></hr>
                                                        <span className={showtab === 1 ? "pull-left forceSingleLine" : "hide"} >

                                                            <a className={showView === 2 ? 'pull-right btn-xs mlxl mt hide' : 'pull-right btn-xs mlxl hide'} onClick={() => toUnLinked(post, 2)}>
                                                                <i className="icon-LinkBroken"></i></a>
                                                            <a className="pull-right">{showtab === 1 ? post.contractArtistDisplay : showtab === 2 ?
                                                                post.trackArtistDisplay : showtab === 3 ? post.releaseArtistName : showtab === 4 ? post.trackArtistDisplay : ""}</a>
                                                        </span>

                                                        <a className='icon-btn primary pull-right btn-xs hide' ><i className="icon-note"></i></a>
                                                        <a className="icon-btn edit pull-right btn-xs hide"><i className="icon-eye" ></i> Edit</a>
                                                        <a className='icon-btn edit pull-right btn-xs hide' ><i className="icon-download1"></i></a>
                                                    </div>

                                                    <div className='pull-right ws-2 mbxl mlxl hide '>

                                                        <div className={showView === 1 ? " badge " : "badge mtxxl mrxl pull-right"}>
                                                            <i className={showtab === 3 ? "icon-plus1 btn-xl badge" : "hide"} onClick={() => addToProject(post, 1)}></i>
                                                            <i className="btn-info btn-xl icon-LinkBroken" onClick={() => toUnLinked(post, 1)}></i>
                                                        </div>

                                                        {/* Unlink{showtab==1? " Contract" :showtab==2? " Songs" :showtab==3? " Release"  :showtab==4? " Tracks" :"" } */}
                                                    </div>

                                                    <div className={showView === 1 ? 'ws-2 pull-right mbxl' : "ws-6 pull-right mtxl "}>

                                                        <span className={showtab === 4 ? 'icon-btn edit btn-s' : "hide"}><TooltipList text="Add Release to Project">
                                                            <i className='icon-plus1 badge' onClick={() => addToProject(post, 1)}></i>
                                                        </TooltipList></span>

                                                        <a className='icon-btn delete btn-s'>

                                                            <span className='pull-left'>
                                                                <TooltipList text={"Unlink " + (showtab === 1 ? "contract" : showtab === 3 ? "song" : showtab === 4 ? "release" : showtab === 2 ? "track" : "")}>
                                                                    <i className='icon-file1' onClick={() => toUnLinked(post, 1)}></i></TooltipList></span>

                                                            <span className={showtab === 1 ? '' : "hide"}>|</span>
                                                            <span className='pull-right'>
                                                                <TooltipList text={"Unlink Contact"}>
                                                                    <i className={showtab === 1 ? 'icon-user-minus' : "hide"} onClick={() => toUnLinked(post, 2)}></i>
                                                                </TooltipList>    </span>


                                                        </a>

                                                    </div>

                                                </div>
                                            </div>

                                        </>

                                    );
                                })
                            }

                            <div className="ws-12">
                                {
                                    (() => {
                                        if (totalRows && totalRows > 10) {
                                            return <Pagination onChange={handleNameOnChange} totalRows={totalRows} />
                                        }

                                    })()
                                }

                            </div>

                        </div>

                    </div>

                    <button className="icon-btn delete pull-right mbl" onClick={onClose}>Close</button>
                </div>
            </Drawer>
        </div>
    )
}